//GeneratorFlag:[NoChange]
import Pricing from './pricing';
import DeliveryDateType from './delivery-date-type';
import Feature from './feature';
import Product from './product';

export default {Pricing, DeliveryDateType, Feature, Product}
export{Pricing, DeliveryDateType, Feature, Product}